module.exports = __webpack_public_path__ + "img/ico_badge_new.68fc9f67.svg";